import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SliderFormPageRoutingModule } from './slider-form-routing.module';

import { SliderFormPage } from './slider-form.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SliderFormPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [SliderFormPage]
})
export class SliderFormPageModule {}
